/** @jsx h */
import { h } from 'preact'

export default props => {
  const { icon, size, className } = props
  if (!icon) {
    return null
  }
  const style = {
    fontSize: `${size || 24}px`
  }
  return (
    <i {...props} style={style} className={`material-icons ${className || ''}`}>
      {icon}
    </i>
  )
}
